'use es6';

import { HELPDESK } from 'FormsUI/constants/WorkspaceFlags';
export const getInboxes = ({
  inboxes: {
    inboxes: {
      value
    }
  }
}) => value;
export const getCurrentInboxId = ({
  inboxes: {
    current: {
      value: {
        id
      }
    }
  }
}) => id;
export const getCurrentInboxName = ({
  inboxes: {
    current: {
      value: {
        name
      }
    }
  }
}) => name;
export const getIsCurrentInboxLoading = ({
  inboxes: {
    current: {
      requested
    }
  }
}) => requested;
export const getCurrentOrFirstInboxId = state => {
  const inboxes = getInboxes(state);
  const currentInboxId = getCurrentInboxId(state);
  return currentInboxId || (inboxes.length === 1 ? inboxes[0].id : null);
};
export const getFirstInboxIdOnly = state => {
  const inboxes = getInboxes(state);
  return inboxes.length === 1 ? inboxes[0].id : null;
};
export const getIsCurrentInboxHelpdesk = state => {
  const inboxes = getInboxes(state);
  const currentInboxId = getCurrentInboxId(state);
  const helpdeskInbox = inboxes.find(inbox => inbox.workspaceFlag === HELPDESK);
  return helpdeskInbox ? currentInboxId === helpdeskInbox.id : false;
};
export const getIsCurrentInboxHelpdeskByInboxId = (state, inboxId) => {
  const inboxes = getInboxes(state);
  const helpdeskInbox = inboxes.find(inbox => inbox.workspaceFlag === HELPDESK);
  return helpdeskInbox ? helpdeskInbox.id === inboxId : false;
};